import { render, staticRenderFns } from "./list-header.component.vue?vue&type=template&id=2d032f30&scoped=true&"
import script from "./list-header.component.vue?vue&type=script&lang=ts&"
export * from "./list-header.component.vue?vue&type=script&lang=ts&"
import style0 from "./list-header.component.vue?vue&type=style&index=0&id=2d032f30&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d032f30",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCheckbox,VCol,VRow})
